export default __webpack_public_path__ + "static/char-s-38-en-56de7193467b36cd15fe122c8148e94c.webp";